import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import API from 'config/ApiConfig';

export default function DeleteTentorForm({ onDelete }) {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [error, setError] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [tentorDetails, setTentorDetails] = useState(null);
  const { userId } = useParams();
  // const API_BASE_URL = 'http://localhost:5000/api/admin/tentor';
  const API_BASE_URL = API.API_ADMIN + '/tentor';
  const JWT_TOKEN = localStorage.getItem('authToken'); // Ganti dengan token yang valid

  function getAuthHeaders() {
    return {
      'Authorization': `Bearer ${JWT_TOKEN}`,
      'Content-Type': 'application/json',
    };
  }

  const fetchUserDetails = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/${userId}`, {
        headers: getAuthHeaders(),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      setTentorDetails(data);
    } catch (error) {
      console.error('Error fetching tentor details:', error);
      setError('Failed to fetch user details. Please try again.');
    }
  };

  useEffect(() => {
    if (userId) {
      fetchUserDetails();
    }
  }, [userId]);

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      const response = await fetch(`${API_BASE_URL}/${userId}`, {
        method: 'DELETE',
        headers: getAuthHeaders(),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      // Handle successful deletion
      console.log('Tentor deleted successfully');
      if (onDelete) onDelete(); // Optional: Callback on success
      setShowConfirmation(false);
      window.location.href = '/admin/tentor'; // Redirect to user list or any other page
    } catch (error) {
      console.error('Error deleting tentor:', error);
      setError('Failed to delete user. Please try again.');
    } finally {
      setIsDeleting(false);
    }
  };
  const handleCancel = () => {
    setShowConfirmation(false);
    window.location.href = "/admin/tentor";
  }

  return (
    <div>
      <h3 className="font-bold uppercase text-lg text-blueGray-700 align-center m-4">Delete Tentor</h3>
      {error && <p className="text-red-500 text-xs">{error}</p>}
      {tentorDetails && !showConfirmation && (
        <div className="mb-4">
          <p><strong>Nama:</strong> {tentorDetails.nama}</p>
          <p><strong>Email:</strong> {tentorDetails.email}</p>
          <p><strong>Alamat:</strong> {tentorDetails.alamat}</p>
          <p><strong>Phone:</strong> {tentorDetails.telepon}</p>
          <button
            type="button"
            className="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none m-4 ease-linear transition-all duration-150"
            onClick={() => setShowConfirmation(true)}
          >
            Delete Tentor
          </button>
        </div>
      )}
      {showConfirmation && (
        <div>
          <p>Are you sure you want to delete this Tentor?</p>
          <button
            type="button"
            className="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none m-4 ease-linear transition-all duration-150"
            onClick={handleDelete}
            disabled={isDeleting}
          >
            {isDeleting ? 'Deleting...' : 'Confirm Delete'}
          </button>
          <button
            type="button"
            className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none m-4 ease-linear transition-all duration-150"
            onClick={handleCancel}
          >
            Cancel
          </button>
        </div>
      )}
    </div>
  );
}

DeleteTentorForm.propTypes = {
  userId: PropTypes.string.isRequired,
  onDelete: PropTypes.func,
};
